export default function ReplyPreview({ replyTo }) {
  if (!replyTo) return null;
 
  return (
    <div style={styles.block}>
      <span style={styles.sender}>{replyTo.senderName}</span>
      <span style={styles.text}>{replyTo.preview}</span>
    </div>
  );
}
 
const styles = {
  block: {
    borderLeft: "3px solid #d6e7db",
    background: "#142d22",
    borderRadius: "0 6px 6px 0",
    padding: "4px 8px",
    marginBottom: 6,
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  sender: {
    fontSize: 12,
    fontWeight: 600,
    color: "#eaedf0ff",
  },
  text: {
    fontSize: 12,
    color: "#8799afff",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
};